export default __webpack_public_path__ + "static/media/regulatory--left-turn-yield-on-green--g1.103fabdc.png";